// extracted by mini-css-extract-plugin
module.exports = {"Backdrop":"backdrop-module--Backdrop--1A2e4"};